exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-title .material-icons {\n  color: #28509b; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/components/main/onboarding/onboarding.component.scss
// module id = ../../../../../src/app/client/components/main/onboarding/onboarding.component.scss
// module chunks = 0